module.exports = __webpack_public_path__ + "./img-yutung_0dfc29db4a1be8f4a030280889d62707.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/img-yutung.png
// module id = 434
// module chunks = 0